import { Subject } from 'rxjs'

export interface Toast {
  content: string
  duration?: number
  error?: boolean
}

export const toastObservable = new Subject<Toast>()
